














































import { Component, Vue } from 'vue-property-decorator';
import { IService } from '@/interfaces';
import {
  readServices,
  dispatchGetServices,
  dispatchDeleteService,
  dispatchDeleteServices,
} from '@/store/admin/accessors';

@Component
export default class Services extends Vue {
  public selected: IService[] = [];
  public pagination: { rowsPerPage; footerProps } = {
    rowsPerPage: 20,
    footerProps: { 'items-per-page-options': [10, 20, 50, 100] },
  };
  public headers = [
    {
      text: this.$vuetify.lang.t('$vuetify.title'),
      sortable: true,
      value: 'name',
      align: 'left',
    },
    {
      text: this.$vuetify.lang.t('$vuetify.proxyHost'),
      sortable: true,
      value: 'proxy_host',
      align: 'left',
    },
    {
      text: this.$vuetify.lang.t('$vuetify.proxyReportHost'),
      sortable: true,
      value: 'proxy_report_host',
      align: 'left',
    },
    {
      text: this.$vuetify.lang.t('$vuetify.proxyCallBackUrl'),
      sortable: true,
      value: 'proxy_callback_url',
      align: 'left',
    },
    {
      text: this.$vuetify.lang.t('$vuetify.passBadMessages'),
      sortable: true,
      value: 'pass_bad_messages',
      align: 'left',
    },
    {
      text: this.$vuetify.lang.t('$vuetify.ignoreUserBans'),
      sortable: true,
      value: 'ignore_user_bans',
      align: 'left',
    },
    {
      text: this.$vuetify.lang.t('$vuetify.actions'),
      value: 'id',
    },
  ];

  get services() {
    return readServices(this.$store);
  }

  public async mounted() {
    await dispatchGetServices(this.$store);
  }

  public async deleteService(id: number) {
    if (confirm(this.$vuetify.lang.t('$vuetify.deleteServicesConfirmation'))) {
      await dispatchDeleteService(this.$store, id);
      await dispatchGetServices(this.$store);
    }
  }

  public async deleteServices() {
    if (confirm(this.$vuetify.lang.t('$vuetify.deleteServicesConfirmation'))) {
      const selected = this.selected.map((item) => item.id as number);
      await dispatchDeleteServices(this.$store, selected);
      await dispatchGetServices(this.$store);
    }
  }
}
